export default "__VITE_ASSET__C7WvW6IN__"